import dayjs from 'dayjs';

// Aceita Date ou string em ISO (YYYY-MM-DD) ou DD-MM-YYYY.
// Retorna '' quando a data e invalida, para nao propagar a string "Invalid Date"
// para as APIs (que respondem 400 ao receber esse valor).
export const formatDateMapped = (date: string | Date) => {
    if (!date) return '';

    let parsedDate;

    if (typeof date === 'string') {
        parsedDate = dayjs(date, 'YYYY-MM-DD', true).isValid()
            ? dayjs(date, 'YYYY-MM-DD', true)
            : dayjs(date, 'DD-MM-YYYY', true).isValid()
                ? dayjs(date, 'DD-MM-YYYY', true)
                : dayjs(date);
    } else {
        parsedDate = dayjs(date);
    }

    return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : '';
}
